namespace Vit {
    export namespace SergenService {
        export const baseUrl = "Administration/Sergen";

        export declare function ListConnections(request: Serenity.ServiceRequest, onSuccess?: (response: Serenity.ListResponse<SergenConnection>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare function ListTables(request: SergenListTablesRequest, onSuccess?: (response: Serenity.ListResponse<SergenTable>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare function ListUIs(request: SergenListUIsRequest, onSuccess?: (response: SergenUIInfo) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare function Generate(request: SergenGenerateRequest, onSuccess?: (response: Serenity.ServiceResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare function GenerateAll(request: SergenGenerateAllRequest, onSuccess?: (response: Serenity.ServiceResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare function SaveUIs(request: SergenSaveUIsRequest, onSuccess?: (response: Serenity.ServiceResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare function SaveGlobals(request: SergenSaveGlobalsRequest, onSuccess?: (response: Serenity.ServiceResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            ListConnections = "Administration/Sergen/ListConnections",
            ListTables = "Administration/Sergen/ListTables",
            ListUIs = "Administration/Sergen/ListUIs",
            Generate = "Administration/Sergen/Generate",
            GenerateAll = "Administration/Sergen/GenerateAll",
            SaveUIs = "Administration/Sergen/SaveUIs",
        }

        [
            "ListConnections",
            "ListTables",
            "ListUIs",
            "Generate",
            "GenerateAll",
            "SaveUIs",
            "SaveGlobals",
        ].forEach(x => {
            (<any>SergenService)[x] = function (r: any, s: any, o: any) {
                return Q.serviceRequest(`${baseUrl}/${x}`, r, s, o);
            };
        });
    }

    export interface SergenConnection {
        Key?: string;
    }

    export interface SergenListTablesRequest extends Serenity.ServiceRequest {
        ConnectionKey?: string;
    }

    export interface SergenListUIsRequest extends Serenity.ServiceRequest {
        ConnectionKey?: string;
        TableKey?: string;
    }

    export interface SergenGenerateRequest extends Serenity.ServiceRequest {
        ConnectionKey?: string;
        Table?: SergenTable;
        GenerateOptions?: SergenGenerateOptions;
    }

    export interface SergenGenerateAllRequest extends Serenity.ServiceRequest {
        ConnectionKey?: string;
        Module?: string;
        GenerateOptions?: SergenGenerateOptions;
    }

    export interface SergenSaveUIsRequest extends Serenity.ServiceRequest {
        ConnectionKey?: string;
        TableKey?: string;
        Model?: string;
    }
    export interface SergenSaveGlobalsRequest extends Serenity.ServiceRequest {
        ConnectionKey?: string;
        Model?: string;
    }

    export interface SergenTable {
        Tablename?: string;
        Identifier?: string;
        Module?: string;
        PermissionKey?: string;
    }

    export interface SergenGenerateOptions {
        Row?: boolean;
        Service?: boolean;
        UI?: boolean;
    }
}